import React, { ChangeEvent, FC, useCallback } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormNodeLinkTermsAgreementModel } from '../../../../shared/kiosk';
import { RichMarkdownIt } from '../../RichMarkdownIt';

interface FormNodeLinkTermsAgreementProps extends FormNodeLinkTermsAgreementModel {
  readonly checked: boolean;
  readonly setChecked: (checked: boolean) => void;
}

export const FormNodeLinkTermsAgreement: FC<FormNodeLinkTermsAgreementProps> = ({
  id,
  markdown,
  checked,
  setChecked,
}) => {
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setChecked(e.target.checked);
    },
    [setChecked],
  );

  const inputId = `agreement-checkbox-${id}`;
  return (
    <FormGroup check className="form-node form-node-link-terms-agreement" id={`agreement-${id}`}>
      <Input checked={checked} id={inputId} onChange={onChange} type="checkbox" />
      <Label check for={inputId}>
        <RichMarkdownIt source={markdown} />
      </Label>
    </FormGroup>
  );
};
